import { Component, Element, Event, EventEmitter, h, Host, Method, Prop, State } from '@stencil/core';
import { If } from '@utils/If';

@Component({
  tag: 'otp-input',
  styleUrl: 'otp-input.scss',
  shadow: false
})
export class OtpInput {
  @Element() el: HTMLElement;

  @Prop() length: number = 6;
  @Prop() name: string;
  @Prop() label: string;
  @Prop() autoFocus: boolean = true;
  @Prop() disabled: boolean = false;
  @Prop() readOnly: boolean = false;
  @Prop() error?: string;
  @Prop() autoSubmit: boolean = false;

  @Event({ bubbles: true, composed: true }) valueChange: EventEmitter<string>;
  @Event({ bubbles: true, composed: true }) otpComplete: EventEmitter<string>;
  @Event({ bubbles: true, composed: true }) otpClear: EventEmitter<void>;

  @State() digits: string[] = Array(this.length).fill('');
  @State() isFocused: boolean = false;
  @State() otpValue: string = '';

  private hiddenInput: HTMLInputElement;
  private lastEmittedOtp: string = '';
  // private isMobile = /Mobi|Android/i.test(navigator.userAgent);

  private focusInput(_index: number) {
    this.hiddenInput.focus();
  }

  onKeypress = (event: any) => {
    const allowedChars = /[0-9]/;
    if (event.key === 'Enter' || event.key === 'Tab') {
      return;
    }
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  };

  private emitOtp() {

    const otp = this.otpValue;
    this.valueChange.emit(otp);

    if (otp.length === 0 && this.lastEmittedOtp !== '') {
      this.otpClear.emit();
      this.lastEmittedOtp = '';
    }

    if (this.autoSubmit && otp.length === this.length) {
      this.otpComplete.emit(otp);
      this.lastEmittedOtp = otp;
    }
  }

  @Method()
  async clear() {
    this.digits = Array(this.length).fill('');
    this.otpValue = "";
    this.emitOtp();
    // this.inputs[5].blur();
  }


  componentDidLoad() {
    if (this.autoFocus) {
      setTimeout(() => this.focusInput(0), 10);
    }
  }

  render() {
    const otpValue = this.digits.join('');
    return (
      <Host>
        {this.label && (
          <label class="otp-label" id="otp-label">
            {this.label}
          </label>
        )}

        {/* Hidden input to support SMS autofill */}
        <div class={`otp-wrapper ${this.error ? 'error' : ''} ${this.isFocused ? 'focused' : ''}`} role="group" aria-labelledby="otp-label" onClick={() => this.hiddenInput?.focus()}>

          <input
            ref={el => this.hiddenInput = el}
            type="tel"
            inputMode="numeric"
            autoComplete="one-time-code"
            class="otp-sms-autofill"
            maxLength={this.length}
            onFocus={(_e) => this.isFocused = true}
            onBlur={(_e) => this.isFocused = false}
            value={this.otpValue}
            onKeyPress={this.onKeypress}
            onInput={e => {
              let rawValue = (e.target as HTMLInputElement).value;
              let sanitizedValue = rawValue.replace(/[^0-9]/g, '').slice(0, this.length);
              this.otpValue = sanitizedValue;
              if (sanitizedValue.length === this.length) {
                this.emitOtp();
              }
            }}
          />
          <div class="otp-dots">
            {Array.from({ length: this.length }).map((_, i) => (
              <div class={`dot ${i < this.otpValue.length ? 'filled' : ''}`}></div>
            ))}
          </div>
        </div>


        <input type="hidden" name={this.name} value={otpValue} autoComplete="off" />

        <If condition={!!this.error} children={<p class="text-sb-danger mt-1 text-xs">{this.error}</p>} />
      </Host>
    );
  }
}
